'use client';

import type { Accordion as AccordionPrimitive } from '@base-ui/react/accordion';
import { cn } from '@zealot/ui/lib/utils';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './accordion';

type SimpleAccordionItem = {
  value: string;
  title: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
};

type SimpleAccordionProps = {
  items: SimpleAccordionItem[];
  value?: AccordionPrimitive.Root.Props['value'];
  defaultValue?: AccordionPrimitive.Root.Props['defaultValue'];
  onValueChange?: AccordionPrimitive.Root.Props['onValueChange'];
  multiple?: boolean;
  disabled?: boolean;
  className?: string;
};

const SimpleAccordion = ({
  items,
  value,
  defaultValue,
  onValueChange,
  multiple,
  disabled,
  className,
}: SimpleAccordionProps) => {
  return (
    <Accordion
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      multiple={multiple}
      disabled={disabled}
      className={cn(className)}
    >
      {items.map((item) => (
        <AccordionItem key={item.value} value={item.value} disabled={item.disabled}>
          <AccordionTrigger>{item.title}</AccordionTrigger>
          <AccordionContent>{item.content}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export type { SimpleAccordionItem, SimpleAccordionProps };
export { SimpleAccordion };
